import { classes, st } from './DragHandle.st.css';
import React, { Ref, HTMLAttributes } from 'react';
import {
  DragAndDropLarge,
  DragAndDropSmall,
} from '@wix/wix-ui-icons-common/system';
import { TooltipCommonProps } from '../common';
import Tooltip from '../Tooltip';

export interface DragHandlePublicAPIProps {
  domRef?: Ref<HTMLDivElement>;
  tabIndex?: number;
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'];
  onKeyDown?: HTMLAttributes<HTMLDivElement>['onKeyDown'];
  'aria-label'?: string;
  'aria-describedby'?: string;
  tooltipContent?: string;
  tooltipProps?: Partial<TooltipCommonProps>;
}

export interface DragHandleProps extends DragHandlePublicAPIProps {
  dataHook?: string;
  dragging?: boolean;
  disabled?: boolean;
  onBlur?: HTMLAttributes<HTMLDivElement>['onBlur'];
  onKeyUp?: HTMLAttributes<HTMLDivElement>['onKeyUp'];
  dragHandleSize?: 'small' | 'large';
}

export function DragHandle(props: DragHandleProps) {
  const {
    dataHook,
    domRef,
    dragging,
    disabled,
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedBy,
    tooltipContent,
    tooltipProps,
    dragHandleSize,
    ...rest
  } = props;

  const dragHandleIcon =
    dragHandleSize === 'small' ? (
      <DragAndDropSmall data-hook="dnd" />
    ) : (
      <DragAndDropLarge data-hook="dnd" />
    );

  return (
    <Tooltip
      dataHook={dataHook}
      disabled={!tooltipContent}
      content={tooltipContent}
      appendTo="window"
      {...tooltipProps}
      aria-describedby={tooltipContent ? undefined : ariaDescribedBy}
    >
      <div
        data-hook="drag-handle-button"
        data-disabled={!!disabled}
        aria-label={tooltipContent || ariaLabel}
        aria-describedby={ariaDescribedBy}
        ref={domRef}
        {...rest}
        role="button"
        className={st(classes.root, {
          disabled,
          dragging,
        })}
      >
        {dragHandleIcon}
      </div>
    </Tooltip>
  );
}
